import { create } from 'zustand';
import { HistoryPrescription } from '../containers/my-central/services';
import { msToTimestamp } from '../components/Timer';

export const defaultWidthTransition = 'width 0.2s ease';

export enum SIDEBAR_WIDTH {
  NOT_EXPANDED = '50px',
  EXPANDED = '115px',
  NOT_RENDERED = 0,
}

export interface BlockedPrescriptionHistory {
  id: number;
  blockExpiresAt: number;
}

export interface OfficeState {
  phoneNumber: string;
  lastSentPhone: string;
  countdownExpiresAt: number | null;
  phoneNumberSended: boolean;
}

export interface MyCentralStore {
  blockedPrescriptionHistory: BlockedPrescriptionHistory[];
  addBlockedPrescriptionHistory(prescriptionHistory: HistoryPrescription): void;
  removeBlockedPrescriptionHistory(prescriptionHistory: HistoryPrescription): void;
  sideBarWidth: SIDEBAR_WIDTH;
  setSideBarWidth: (value: SIDEBAR_WIDTH) => void;
  officeState: OfficeState;
  setOfficeState: (state: Partial<OfficeState>) => void;
  resetOfficeState: () => void;
}

const FIVE_MINUTES_IN_MS = 300000;

const initialOfficeState: OfficeState = {
  phoneNumber: '',
  lastSentPhone: '',
  countdownExpiresAt: null,
  phoneNumberSended: false,
};

export const useMyCentralStore = create<MyCentralStore>()((set, get) => ({
  blockedPrescriptionHistory: [],
  setSideBarWidth: (width) => set((prev) => ({ ...prev, sideBarWidth: width })),
  sideBarWidth: SIDEBAR_WIDTH.NOT_RENDERED,
  officeState: initialOfficeState,
  setOfficeState: (state) =>
    set((prev) => ({
      ...prev,
      officeState: { ...prev.officeState, ...state },
    })),
  resetOfficeState: () => set((prev) => ({ ...prev, officeState: initialOfficeState })),
  addBlockedPrescriptionHistory(prescriptionHistory: HistoryPrescription) {
    set((prev) => {
      return {
        ...prev,
        blockedPrescriptionHistory: prev.blockedPrescriptionHistory.concat({
          id: prescriptionHistory.idPrescricao,
          blockExpiresAt: msToTimestamp(FIVE_MINUTES_IN_MS),
        }),
      };
    });
  },
  removeBlockedPrescriptionHistory(prescriptionHistory: HistoryPrescription) {
    set((prev) => {
      return {
        ...prev,
        blockedPrescriptionHistory: prev.blockedPrescriptionHistory.filter(
          (blockedPrescription) => blockedPrescription.id !== prescriptionHistory.idPrescricao
        ),
      };
    });
  },
}));
